import { Trans, withI18n } from '@lingui/react'
import { bool, func, string } from 'prop-types'

import { PRODUCT_TARGET_PAGE_CODE } from 'shared/consts'
import { TARGET_PAGE_CODE_FIELD } from 'shared/consts/formFields'
import Button from 'views/components/atoms/Button'
import Form from 'views/components/atoms/Form'
import IconTick from 'views/components/atoms/Icon/IconTick'
import ButtonTooltip from 'views/components/molecules/ButtonTooltip'
import Select from 'views/components/molecules/Select'
import ProductStatus from 'views/components/organisms/ProductStatus'
import { isProductAvailable } from 'views/utils/productUtils'
import { i18nType, ProductType } from 'views/utils/propTypes'
import { pickRequired } from 'views/utils/propTypeUtils'

import BuyBoxDeliveryCosts from './BuyBoxDeliveryCosts'

const BuyBoxSendEmailForm = ({
  i18n,
  id,
  prescriptionType,
  stockStatus,
  isFreeDelivery,
  useLinkForDeliveryCosts,
}) => {
  const isAvailable = isProductAvailable(stockStatus)

  return (
    <Form name={`email-on-availability-${id}`} action="/emailOnAvailability.go">
      <input name="eOAAction" type="hidden" value="subscribe" />
      <input
        name={TARGET_PAGE_CODE_FIELD}
        type="hidden"
        value={PRODUCT_TARGET_PAGE_CODE}
      />
      <input name="productCode" type="hidden" value={id} />
      {prescriptionType ? (
        <input name="prescriptionType" type="hidden" value={prescriptionType} />
      ) : null}
      <div className="l-flex u-margin--bottom@medium u-margin-large--bottom@small-tiny o-BuyBoxSendEmailForm--status">
        <div className="l-flex__primary">
          <ProductStatus stockStatus={stockStatus} />
        </div>
        {isAvailable && (
          <BuyBoxDeliveryCosts
            isFreeDelivery={isFreeDelivery}
            prescriptionType={prescriptionType}
            useLink={useLinkForDeliveryCosts}
          />
        )}
      </div>
      <div className="l-flex o-BuyBoxSendEmailForm--form">
        <div className="u-margin-large--right o-BuyBox__grow--one-quarter@small-tiny o-BuyBoxSendEmailForm--form-select">
          <Select
            id="product_quantity_BuyBox"
            name="quantity"
            label={i18n._('general.label.quantity')}
            options={[{ value: 1, text: '1' }]}
            floatingLabel
            disabled
          />
        </div>
        <div className="l-flex__primary o-BuyBox__grow--three-quarter@small-tiny o-BuyBoxSendEmailForm__button_activate">
          <div data-clientside-hook="o-BuyBoxSendEmailForm__button__user-logged-out">
            <ButtonTooltip
              name="send-email-notification-tooltip"
              id="send-email-notification-tooltip"
              text={i18n._('general.loginRequired')}
              data-clientside-hook="add-to-wishlist-tooltip"
              buttonText={i18n._('backInStock.button.activate')}
              ButtonType={Button}
              inline={false}
              fullWidth
            />
          </div>
          <div
            className="u-hidden"
            data-clientside-hook="o-BuyBoxSendEmailForm__button__user-logged-in"
          >
            <Button
              name="email-on-availability-button"
              data-clientside-hook="o-BuyBoxSendEmailForm__button"
              type="submit"
            >
              <span
                className="a-h3 u-no-margin u-font-weight--normal"
                data-clientside-hook="o-BuyBoxSendEmailForm__text_activate"
              >
                <Trans id="backInStock.button.activate" />
              </span>
              <span
                className="a-h3 u-no-margin u-font-weight--normal u-hidden"
                data-clientside-hook="o-BuyBoxSendEmailForm__text_activated"
              >
                <Trans id="backInStock.label.active" />
                <IconTick />
              </span>
            </Button>
          </div>
        </div>
      </div>
    </Form>
  )
}

BuyBoxSendEmailForm.propTypes = {
  ...pickRequired(ProductType, ['id', 'stockStatus']),
  i18n: i18nType.isRequired,
  prescriptionType: string,
  isFreeDelivery: func,
  useLinkForDeliveryCosts: bool,
}
BuyBoxSendEmailForm.defaultProps = {
  isFreeDelivery: () => false,
  prescriptionType: null,
  useLinkForDeliveryCosts: false,
}

export default withI18n()(BuyBoxSendEmailForm)
